module.exports = __webpack_public_path__ + "static/media/trip_list_add_button.ca2aaafa.svg";